import { Observable, from, of } from 'rxjs';
import { flatMap, combineAll } from 'rxjs/operators';

export function throttleJoin<T>(observables: Observable<T>[], concurrency: number) : Observable<T[]>{
    if(observables.length == 0) return of([]);
    return from(observables)
        .pipe(flatMap((observable) => {
            return observable
        },(_,result) => {
            return of(result)
        }, concurrency))
        .pipe(combineAll());
}